import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(
            _ctx.$vuetify.display.mobile
                ? 'default_card_mobile elevation-0 ma-0'
                : 'default_card dashboard_card elevation-0'
        )
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { "primary-title": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            style: {"flex-wrap":"nowrap"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "3",
                class: "ml-0 mt-0 mb-auto pt-0 pb-auto d-flex flex-grow-0 flex-shrink-1"
              }, {
                default: _withCtx(() => [
                  (_ctx.activeBack)
                    ? (_openBlock(), _createBlock(_component_v_btn_back, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClosingVue')))
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }),
              (_ctx.showTagSelect)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "4"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isAllowedTo)
                        ? (_openBlock(), _createBlock(_component_v_select_filled, {
                            key: 0,
                            modelValue: _ctx._selectedTags,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._selectedTags) = $event)),
                            items: _ctx.data.tags,
                            "item-value": "id",
                            multiple: "",
                            class: "mt-0 mb-0 pt-0 pb-0 mr-4",
                            label: "Etiquettes",
                            "data-cy": "BarChartCard-selectedTags",
                            density: "compact",
                            "item-title": (item) => item.name
                          }, {
                            selection: _withCtx(({ item }) => [
                              _createVNode(_component_v_chip, {
                                label: "",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items", "item-title"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, {
                cols: _ctx.showTagSelect ? 5 : 9,
                class: "d-flex flex-grow-1 flex-shrink-0 justify-end"
              }, {
                default: _withCtx(() => [
                  (_ctx.showYearNMinus1)
                    ? _withDirectives((_openBlock(), _createBlock(_component_v_switch, {
                        key: 0,
                        modelValue: _ctx._yearNMinus1,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._yearNMinus1) = $event)),
                        class: "ml-4 mt-1 mb-0 pt-0 pb-0",
                        label: "N-1",
                        "data-cy": "BarChartCard-yearNMinus1"
                      }, null, 8, ["modelValue"])), [
                        [_vShow, !_ctx.detail]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.showCumulative)
                    ? (_openBlock(), _createBlock(_component_v_switch, {
                        key: 1,
                        modelValue: _ctx.cumulative,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cumulative) = $event)),
                        class: "ml-4 mt-1 mb-0 pt-0 pb-0",
                        label: "Cumulé",
                        "data-cy": "BarChartCard-cumulative"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, {
        style: {"text-align":"center"},
        class: "pa-0"
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                size: 70,
                width: 7,
                color: "primary",
                indeterminate: "",
                style: {"margin":"24px"}
              }))
            : (_ctx.chartData)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.chartData)
                    ? (_openBlock(), _createBlock(_component_bar_chart, {
                        key: 0,
                        data: _ctx.chartData,
                        options: _ctx.options,
                        height: _ctx.$vuetify.display.mobile ? 200 : 350
                      }, null, 8, ["data", "options", "height"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}